// @ts-nocheck

const getMimeTypes = (fileTypes) => {
	const mimeTypesTable = {
		csv: ".csv",
		excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		doc: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
		pdf: "application/pdf",
		email: "message/rfc822",

		camera: ["image/gif", "image/jpeg", "image/png", "image/tiff"]
	}

	const mimeTypes = []

	fileTypes.forEach((fileType) => {
		const mimeType = mimeTypesTable[fileType]

		if (Array.isArray(mimeType)) mimeTypes.push(...mimeType)
		else mimeTypes.push(mimeType)
	})

	return mimeTypes.join(", ")
}

export default getMimeTypes
